module.exports = __webpack_public_path__ + "icon-framework-angular.1wX9es4V.svg";